<template>
  <Diff
    v-if="diffTree"
    class="DiffLaptops"
    :diffTree="diffTree"
    :doCompactMatched="doCompactMatched"
    :keys="$ta('diffKeys')"
    @accept="accept"
    @reject="reject" />
</template>

<script>
import Diff from './Diff'
import getLaptopDiff from './getLaptopDiff'

export default {
  components: {
    Diff,
  },
  props: {
    doCompactMatched: { type: Boolean, default: false },
    original: { type: Object, required: true },
    incoming: { type: Object, required: true },
  },
  computed: {
    diffTree() {
      return getLaptopDiff(this.original, this.incoming)
    },
  },
  methods: {
    accept(key) {
      const value = this.incoming[key]

      this.original[key] = value

      this.$emit('accept', { key, value })
    },
    reject(key) {
      this.incoming[key] = null

      this.$emit('reject', { key })
    },
  },
}
</script>

<style lang="scss">
.DiffLaptops {
}
</style>

<i18n>
{
  "en": {
    "diffKeys": [
      "",
      "Original",
      "Incoming"
    ]
  }
}
</i18n>
